import React from "react";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import CloseIcon from "@/public/icons/x.svg";

interface CloseButtonProps {
	className?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CloseButton: FCWithHTMLAttributes<CloseButtonProps> = ({
	className,
	onClick,
}) => {
	return (
		<button
			className={`flex h-10 w-10 flex-grow-0 items-center justify-center rounded-md bg-green-800 hover:bg-green-900 ${className}`}
			onClick={onClick}
			aria-label="Hide Banner"
		>
			<CloseIcon className="fill-white" />
		</button>
	);
};

export default CloseButton;
